// Import
import React from 'react';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardMedia from '@material-ui/core/CardMedia';
import { makeStyles } from '@material-ui/core/styles';

// Material UI
const useStyles = makeStyles((theme) => ({
    root: {
        minWidth: 200,
        maxWidth: 200,
        [theme.breakpoints.up('lg')]: {
            minWidth: 275,
            maxWidth: 275,
        },
        [theme.breakpoints.down('xs')]: {
            minWidth: 175,
            maxWidth: 200,
        },
    },
    header: {
        height: 5,
    },
}));

export default function ProjectCard({ name, image }) {
    const classes = useStyles();

    return (
        <Card className={classes.root} variant="outlined">
            <CardHeader className={classes.header} titleTypographyProps={{ variant: 'h7' }} title={name} />
            <CardMedia component="img" src={image} />
        </Card>
    );
}
